module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/50e0a8443712a7d3201d76c311c5c5c7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_minimise.svg
// module id = Do0+
// module chunks = 0